import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      appState: { returnTo: '/dashboard' }
    });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-light-grey py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-12">
          <img
            src="/ds-alternate.png"
            alt="DayShift Sports MMA Logo"
            width={512}
            height={512}
            className="mx-auto w-44 h-44 sm:w-56 sm:h-56 object-contain"
          />
        </div>
        
        <div className="bg-white rounded-xl p-10 shadow-card">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-dark-grey">
              Welcome
            </h2>
            <p className="mt-2 text-medium-grey">
              Sign in to access your fantasy MMA league
            </p>
          </div>
          
          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center px-4 py-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-deep-red hover:bg-bright-red focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-deep-red transition-colors"
          >
            Log In / Sign Up
          </button>
          
          <div className="text-center mt-8">
            <p className="text-sm text-medium-grey">
              By signing in, you agree to our{" "}
              <button className="text-deep-red hover:text-bright-red">Terms of Service</button>{" "}
              and{" "}
              <button className="text-deep-red hover:text-bright-red">Privacy Policy</button>
            </p>
          </div>
        </div>
        
        <div className="text-center mt-6">
          <p className="text-xs text-medium-grey">
            &copy; {new Date().getFullYear()} DayShift Sports. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
